import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAmplitudeExperiment } from 'contexts/AmplitudeExperimentContext';
import { trackEvent } from 'utils/analyticsUtils';

const FEATURE_FLAG = 'signup-shakeout-test';
const TEST_PATHS = [
    '/join',
    '/join/account',
    '/join/delivery',
    '/join/payment',
    '/join/membership',
    '/join/confirmation',
];

/**
 * Track an 'experiment viewed' event for the 'signup-shakeout-test' feature flag.
 * This is a non-customer-facing A/A experiment to try out & learn about the
 * data we get by using the Amplitude Experiment SDK.
 * NOTE: This event is in addition to the built-in exposure events from the Amplitude SDK.
 * @returns {undefined}
 */
function useTrackSecretAmplitudeExperiment() {
    const { experimentClientIsReady, getFeatureFlagVariant } = useAmplitudeExperiment();
    const { pathname } = useLocation();

    useEffect(() => {
        const isTestPath = TEST_PATHS.includes(pathname);

        if (isTestPath && experimentClientIsReady) {
            const variant = getFeatureFlagVariant(FEATURE_FLAG);
            if (variant) {
                trackEvent('experiment viewed', {
                    pathname,
                    variant,
                    flag_key: FEATURE_FLAG,
                });
            }
        }
    }, [pathname, experimentClientIsReady]);
}

export { useTrackSecretAmplitudeExperiment };
